import { sendToJava } from "@tipico/java-streams";
import { parse } from "query-string";
import { interval, merge, of } from "rxjs";
import { map } from "rxjs/operators";

const START_SCREEN_PING_ACTION = "MachineAppPing";
const PING_MESSAGE = "ping";

const toMiliseconds = (seconds: number) => seconds * 1000;

function intervalInSeconds(defaultValue: number): number {
    if (document.location) {
        const pingInterval = parse(document.location.search).pingInterval;
        if (pingInterval && !Array.isArray(pingInterval)) {
            return parseInt(pingInterval, 10) || defaultValue;
        }
    }
    return defaultValue;
}

function startPinging() {
    // false positive deprecation warning
    // reference issue: https://github.com/palantir/tslint/issues/4522
    // tslint:disable-next-line: deprecation
    return merge(of(0), interval(toMiliseconds(intervalInSeconds(15))))
        .pipe(
            map(() => PING_MESSAGE),
            sendToJava(START_SCREEN_PING_ACTION)
        )
        .subscribe((pong: any) => {
            // tslint:disable-next-line:no-console
            console.log("watchdog Pong:", pong);
        });
}

export default startPinging;
